// Ingredient classifier for auto-categorization
const INGREDIENT_CLASSIFIER = {
  vegetables: [
    'artichoke', 'arugula', 'asparagus', 'bean sprouts', 'beet', 'bell pepper', 'bok choy',
    'broccoli', 'brussels sprouts', 'cabbage', 'carrot', 'carrots', 'cauliflower', 'celery',
    'chard', 'collard greens', 'corn', 'cucumber', 'eggplant', 'endive', 'fennel', 'garlic',
    'ginger', 'green beans', 'green onion', 'jalapeno', 'kale', 'leek', 'lettuce', 'mushroom',
    'mushrooms', 'okra', 'onion', 'onions', 'parsnip', 'peas', 'pepper', 'peppers', 'potato',
    'potatoes', 'pumpkin', 'radish', 'romaine', 'scallion', 'shallot', 'spinach', 'squash',
    'sweet potato', 'tomato', 'tomatoes', 'turnip', 'watercress', 'zucchini'
  ],
  fruits: [
    'apple', 'apples', 'apricot', 'avocado', 'banana', 'bananas', 'blackberry', 'blueberry',
    'blueberries', 'cantaloupe', 'cherry', 'cherries', 'clementine', 'coconut', 'cranberry',
    'date', 'dates', 'dragon fruit', 'fig', 'grape', 'grapes', 'grapefruit', 'guava',
    'honeydew', 'kiwi', 'lemon', 'lemons', 'lime', 'limes', 'lychee', 'mango', 'mangoes',
    'melon', 'nectarine', 'orange', 'oranges', 'papaya', 'passionfruit', 'peach', 'peaches',
    'pear', 'pears', 'persimmon', 'pineapple', 'plum', 'plums', 'pomegranate', 'raspberry',
    'raspberries', 'strawberry', 'strawberries', 'tangerine', 'watermelon'
  ],
  meats_seafood: [
    'anchovies', 'bacon', 'beef', 'brisket', 'chicken', 'chicken breast', 'chicken thigh',
    'chicken wings', 'clam', 'clams', 'cod', 'crab', 'duck', 'fish', 'ground beef',
    'ground chicken', 'ground pork', 'ground turkey', 'ham', 'hot dog', 'kielbasa', 'lamb',
    'lobster', 'meatball', 'meatballs', 'mussel', 'mussels', 'oyster', 'oysters', 'pepperoni',
    'pork', 'pork chop', 'prosciutto', 'ribeye', 'ribs', 'salami', 'salmon', 'sardines',
    'sausage', 'scallop', 'scallops', 'shrimp', 'sirloin', 'steak', 'tilapia', 'tuna',
    'turkey', 'veal'
  ],
  dairy_eggs: [
    'blue cheese', 'brie', 'butter', 'buttermilk', 'cheddar', 'cheese', 'cottage cheese',
    'cream', 'cream cheese', 'egg', 'eggs', 'feta', 'goat cheese', 'gouda', 'greek yogurt',
    'gruyere', 'half and half', 'heavy cream', 'milk', 'mozzarella', 'parmesan', 'provolone',
    'ricotta', 'sour cream', 'swiss cheese', 'whipped cream', 'yogurt'
  ],
  grains_bread: [
    'bagel', 'baguette', 'barley', 'basmati rice', 'bread', 'brioche', 'brown rice', 'bulgur',
    'cereal', 'ciabatta', 'couscous', 'crackers', 'croissant', 'english muffin', 'farro',
    'flatbread', 'flour', 'granola', 'jasmine rice', 'linguine', 'macaroni', 'naan', 'noodles',
    'oats', 'orzo', 'pancake mix', 'pasta', 'penne', 'pita', 'polenta', 'quinoa', 'ramen',
    'rice', 'risotto', 'roll', 'rolls', 'rotini', 'sourdough', 'spaghetti', 'tortilla',
    'tortillas', 'white rice', 'whole wheat bread'
  ],
  pantry_other: [
    'agave', 'almond butter', 'almonds', 'balsamic vinegar', 'basil', 'bay leaf', 'bbq sauce',
    'black beans', 'black pepper', 'broth', 'brown sugar', 'capers', 'cashews', 'cayenne',
    'chickpeas', 'chili flakes', 'chili powder', 'chocolate', 'chocolate chips', 'cilantro',
    'cinnamon', 'cocoa', 'coconut milk', 'coconut oil', 'coffee', 'coriander', 'cumin',
    'curry powder', 'dijon mustard', 'dill', 'fish sauce', 'garlic powder', 'gochujang',
    'harissa', 'hazelnuts', 'honey', 'hot sauce', 'hummus', 'jam', 'jelly', 'ketchup',
    'lentils', 'maple syrup', 'marinara', 'mayonnaise', 'mint', 'miso', 'mustard', 'nutmeg',
    'olive oil', 'olives', 'onion powder', 'oregano', 'paprika', 'parsley', 'peanut butter',
    'peanuts', 'pecans', 'pesto', 'pickles', 'pine nuts', 'ranch', 'red pepper flakes',
    'red wine vinegar', 'relish', 'rice vinegar', 'rosemary', 'sage', 'salsa', 'salt',
    'sesame oil', 'sesame seeds', 'soy sauce', 'sriracha', 'stock', 'sugar', 'sunflower seeds',
    'tahini', 'tamari', 'tarragon', 'teriyaki sauce', 'thyme', 'tomato paste', 'tomato sauce',
    'turmeric', 'vanilla', 'vegetable oil', 'vinegar', 'walnuts', 'white sugar', 'white vinegar',
    'worcestershire sauce'
  ]
};

// Explicit non-food blocklist — animals, electronics, household, clothing, body parts, etc.
const NON_FOOD_BLOCKLIST = [
  // Animals
  'dog', 'cat', 'horse', 'cow', 'pig', 'sheep', 'goat', 'rabbit', 'hamster', 'parrot',
  'bird', 'mouse', 'rat', 'snake', 'lizard', 'frog', 'turtle', 'monkey', 'elephant',
  'lion', 'tiger', 'bear', 'wolf', 'fox', 'deer', 'giraffe', 'zebra', 'penguin',
  'dolphin', 'whale', 'shark', 'goldfish', 'kitten', 'puppy', 'donkey', 'camel',
  // Electronics
  'laptop', 'phone', 'computer', 'tablet', 'keyboard', 'mouse pad', 'monitor', 'tv',
  'television', 'remote', 'charger', 'cable', 'headphones', 'earbuds', 'speaker',
  'camera', 'printer', 'router', 'modem', 'usb', 'battery', 'iphone', 'ipad', 'android',
  // Household / Furniture
  'table', 'chair', 'desk', 'sofa', 'couch', 'bed', 'pillow', 'blanket', 'carpet',
  'rug', 'curtain', 'lamp', 'shelf', 'drawer', 'cabinet', 'door', 'window', 'wall',
  'floor', 'ceiling', 'roof', 'stairs', 'toilet', 'sink', 'bathtub', 'shower',
  'mirror', 'towel', 'mattress', 'wardrobe', 'bookshelf', 'bench', 'stool',
  // Cleaning / Bathroom
  'soap', 'shampoo', 'detergent', 'bleach', 'sponge', 'mop', 'broom', 'vacuum',
  'toothbrush', 'toothpaste', 'deodorant', 'lotion', 'sunscreen', 'perfume',
  // Clothing / Accessories
  'shirt', 'pants', 'jeans', 'shorts', 'dress', 'skirt', 'jacket', 'coat', 'sweater',
  'hoodie', 'socks', 'shoes', 'boots', 'sandals', 'hat', 'cap', 'gloves', 'scarf',
  'belt', 'tie', 'underwear', 'bra', 'wallet', 'purse', 'backpack', 'watch',
  'glasses', 'sunglasses', 'ring', 'necklace', 'bracelet', 'earring',
  // Office / School
  'pen', 'pencil', 'eraser', 'ruler', 'notebook', 'paper', 'book', 'stapler',
  'scissors', 'tape', 'glue', 'marker', 'crayon', 'chalk', 'envelope', 'stamp',
  // Tools / Hardware
  'hammer', 'nail', 'screw', 'screwdriver', 'wrench', 'drill', 'saw', 'pliers',
  'wire', 'rope', 'chain', 'bolt', 'nut', 'washer', 'pipe', 'hose',
  // Body parts
  'hand', 'foot', 'finger', 'toe', 'arm', 'leg', 'head', 'face', 'nose', 'ear',
  'eye', 'mouth', 'teeth', 'tongue', 'hair', 'skin', 'bone', 'blood', 'brain',
  'heart', 'lung', 'stomach', 'knee', 'elbow', 'shoulder', 'neck', 'back',
  // Vehicles / Transport
  'car', 'truck', 'bus', 'bike', 'bicycle', 'motorcycle', 'train', 'plane',
  'boat', 'ship', 'helicopter', 'tire', 'wheel', 'engine',
  // Nature (non-food)
  'rock', 'stone', 'sand', 'dirt', 'mud', 'grass', 'tree', 'leaf', 'flower',
  'wood', 'stick', 'branch', 'log', 'metal', 'plastic', 'glass', 'rubber',
  // Misc non-food
  'money', 'coin', 'key', 'lock', 'candle', 'match', 'cigarette', 'drug',
  'medicine', 'pill', 'poison', 'paint', 'ink', 'toy', 'ball', 'doll',
  'game', 'card', 'dice', 'puzzle', 'sticker', 'photo', 'picture', 'flag',
  'person', 'baby', 'child', 'man', 'woman', 'human', 'people',
];

// Fast client-side blocklist check (rejects known non-food items instantly)
export const isBlocklisted = (ingredientName) => {
  const lower = ingredientName.toLowerCase().trim();
  return NON_FOOD_BLOCKLIST.includes(lower);
};

// Detect if an ingredient is a liquid based on its name
const LIQUID_KEYWORDS = [
  'broth', 'stock', 'juice', 'milk', 'cream', 'water', 'oil', 'vinegar',
  'sauce', 'soup', 'wine', 'beer', 'liquor', 'syrup', 'honey', 'extract',
  'paste', 'puree', 'coconut milk', 'buttermilk', 'yogurt', 'yoghurt',
  'kefir', 'ghee', 'soy sauce', 'fish sauce', 'hot sauce', 'sriracha',
  'worcestershire', 'tahini', 'maple syrup', 'agave', 'molasses',
  'lemon juice', 'lime juice', 'orange juice', 'balsamic', 'dressing',
  'marinade', 'condensed milk', 'evaporated milk', 'coconut cream',
];

export const isLiquidIngredient = (ingredientName) => {
  const lower = ingredientName.toLowerCase().trim();
  return LIQUID_KEYWORDS.some(kw => lower.includes(kw) || kw.includes(lower));
};

// Function to auto-classify an ingredient
export const classifyIngredient = (ingredientName) => {
  const lower = ingredientName.toLowerCase().trim();
  
  for (const [category, items] of Object.entries(INGREDIENT_CLASSIFIER)) {
    if (items.includes(lower)) return category;
    for (const item of items) {
      if (lower.includes(item) || item.includes(lower)) return category;
    }
  }
  
  return 'pantry_other';
};

// Common units for quantity parsing
const UNITS = [
  'cups?', 'cup', 'tablespoons?', 'tbsp', 'teaspoons?', 'tsp', 'ounces?', 'oz',
  'pounds?', 'lbs?', 'lb', 'grams?', 'g', 'kilograms?', 'kg', 'ml', 'liters?', 'l',
  'cloves?', 'slices?', 'pieces?', 'bunch', 'bunches', 'heads?', 'stalks?',
  'cans?', 'bottles?', 'packages?', 'bags?', 'boxes?', 'jars?', 'containers?',
  'pinch', 'pinches', 'dash', 'dashes', 'sprigs?', 'leaves?', 'strips?'
];

// Function to parse ingredient with quantity from string like "2 cups rice" or "200g cheese"
export const parseIngredientWithQuantity = (input) => {
  const trimmed = input.trim();
  if (!trimmed) return null;
  
  const unitsPattern = UNITS.join('|');
  const patternWithUnit = new RegExp(`^([\\d\\/\\.]+)\\s*(${unitsPattern})\\s+(.+)$`, 'i');
  const patternAttachedUnit = new RegExp(`^(\\d+)\\s*(g|kg|ml|l|oz|lb)\\s+(.+)$`, 'i');
  const patternNumberOnly = /^([\d\/\.]+)\s+(.+)$/;
  
  let quantity = null;
  let unit = null;
  let name = trimmed;
  
  let match = trimmed.match(patternAttachedUnit);
  if (match) {
    quantity = match[1];
    unit = match[2].toLowerCase();
    const unitMap = { 'g': 'grams', 'kg': 'kilograms', 'ml': 'ml', 'l': 'liters', 'oz': 'ounces', 'lb': 'pounds' };
    unit = unitMap[unit] || unit;
    name = match[3].trim();
  }
  
  if (!match) {
    match = trimmed.match(patternWithUnit);
    if (match) {
      quantity = match[1];
      unit = match[2].toLowerCase();
      name = match[3].trim();
    }
  }
  
  if (!match) {
    match = trimmed.match(patternNumberOnly);
    if (match) {
      quantity = match[1];
      unit = null;
      name = match[2].trim();
    }
  }
  
  let display = name;
  if (quantity) {
    display = unit ? `${quantity} ${unit} ${name}` : `${quantity} ${name}`;
  }
  
  return { name, quantity, unit, display };
};

// Resize and compress image before uploading
export const optimizeImage = async (file, maxWidth = 1024) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const canvas = document.createElement('canvas');
    
    img.onload = () => {
      let width = img.width;
      let height = img.height;
      
      if (width > maxWidth) {
        height = (height * maxWidth) / width;
        width = maxWidth;
      }
      
      canvas.width = width;
      canvas.height = height;
      
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      
      canvas.toBlob(
        (blob) => resolve(blob || file),
        'image/webp',
        0.85
      );
    };
    
    img.onerror = () => resolve(file);
    img.src = URL.createObjectURL(file);
  });
};
